import http from '@core/fetch'

export default {
  getNotice: body =>
    http('/p/wedding/index.php/Admin/APIMerchantNotice/index', { body }),

  check: body =>
    http('/p/wedding/index.php/Admin/APIMerchantNotice/check', { body }),

  edit: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchantNotice/edit', { body }),

  del: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchantNotice/delete', { body })
}
